<template>
  <div class="home">
    <navbar :is-active="1"></navbar>
    <div class="body">
      <CommercialSidebar active="productos" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Productos</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Código de Productos" v-model="product_code" @keyup="search" @keypress="onlynumber(e)"/>
          <input type="text" placeholder="Nombre del Producto"  v-model="nombre_producto" @keyup="search"/>
          <select v-model="product_brand" @change="search">
            <option selected="selected" disabled value="0">Marca</option>
            <option v-for="valor of brand" :key="valor.id" :value="valor.id">{{ valor.name}}</option>
          </select>
          <select v-model="product_image" @change="search">
            <option selected="selected" disabled value="3">Imagen precargada</option>
            <option value="1">Si</option>
            <option value="0">No</option>
          </select>
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>
        </div>
        <div class="page__buttons">
          <button @click="createProduct()" class="button">
            Nuevo Producto <i class="fas fa-plus"></i>
          </button>
          <button @click="importProduct()" class="button">
            Carga Masiva <i class="fas fa-upload"></i>
          </button>
          <ButtonExport
            :data="products_export"
            :columns="columns"
            :sheet-name="'Datos Productos'"
            :file-name="'Reporte Productos'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Accion</p>
          </div>
          <div class="table-body" >
            <div class="data" :key="product.id" v-for="product of products">
              <p >
                {{ codeFormat(product.product_code) }}
              </p>
              <p>{{ product.product_name }}</p>
              <p>{{ product.product_descripcion }}</p>
              <p>{{ product.type }}</p>
              <p>{{ product.brand }}</p>
              <p>
                {{ dateFormat(product.created_at) }}
              </p>
              <p>
                {{ dateFormat(product.updated_at) }}
              </p>
              <p>{{ conditionalFormatValue(product.product_path) }}</p>
              <div class="dropdown">
                  <button class="button" @click="show('id-dropdown-content'+product.id)">
                    <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                  <div @mouseleave="show('id-dropdown-content'+product.id)" class="dropdown-content" :id="'id-dropdown-content'+product.id">
                      <button class="dropdown-item" @click="openModal(product.id)">
                        <i class="fas fa-bars"></i> Desplegar modal
                      </button>
                      <router-link :to="{ path: '/Client/ShowProduct', query: { id: product.id }}" class="dropdown-item">
                        <i class="far fa-eye"></i> Ver Detalle
                      </router-link>
                    <button class="dropdown-item" @click="deleteProduct(product.id)">
                      <i class="fas fa-trash"></i> Eliminar
                    </button>
                      <div class="dropdown-item-special">
                        Activado
                        <input
                            :id="'check_'+product.id"
                            type="checkbox"
                            :checked="(product.product_status === 1)"
                            class="dropdown-checkbox"
                            @change="activateProduct($event, product.id)"
                        />
                        <label class="wrapper" :for="'check_'+product.id">
                          <span class="circle"></span>
                        </label>
                      </div>
                  </div>
                </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>

        <vue-final-modal v-if="dataModal" v-model="showModal"  classes="modal-container" content-class="modal-content">
          <h2>Datos Producto: </h2>
          <div id="columnas">
            <li> <span style="font-weight: bold;"> Código de Producto: </span>  <span>{{ dataModal.product_code}} </span></li>
            <li> <span style="font-weight: bold;"> Nombre de Producto: </span>  <span>{{ dataModal.product_name}} </span></li>
            <li> <span style="font-weight: bold;"> Descripcion de Producto: </span>  <span>{{ dataModal.product_descripcion}} </span></li>
            <li> <span style="font-weight: bold;"> Tipo de Producto: </span>  <span>{{ dataModal.type}} </span></li>
            <li> <span style="font-weight: bold;"> Marca de Producto: </span>  <span>{{ dataModal.brand}} </span></li>
            <li> <span style="font-weight: bold;"> Fecha de Registro: </span>  <span>{{ dataModal.created_at}} </span></li>
            <li> <span style="font-weight: bold;"> Nombre de Actualización: </span>  <span>{{ dataModal.updated_at}} </span></li>
            <li> <span style="font-weight: bold;"> Imagen Cargada: </span>  <span>{{ dataModal.product_path}} </span></li>

          </div>

          <div class="page__table"  style="width: 100%">
            <h4>Sucursales</h4>
            <section class="page__filters" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
              <div class="input" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
                <input  @keyup="searchBranchOffice" type="text" v-model="search_branch_office" placeholder="Buscar sucursal" style="outline: none; padding: 0px 0px; border: 0px !important;">
                <i class="fas fa-search"></i>
              </div>
            </section>

            <div class="table-headers"  style="width: 100%">
              <p v-for="{ label } of columnsModal" :key="label">{{ label }}</p>
            </div>
            <div class="table-body"  style="width: 100%">
              <div class="data" v-for="product of dataModal.branchoffice.data" :key="product.id" style="justify-content: center;">
                  <p>{{ product.branch_code }}</p>
                  <p>{{ product.branch_name }}</p>
                  <p>{{ product.branch_nickname }}</p>
                  <p>{{ product.branch_direction }}</p>
                  <p>{{ product.branch_reference }}</p>
              </div>

              <div style="text-align: center;" v-if="productEmpty">
                <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
              </div>
            </div>

            <div class="page__pagination" style="padding-top: 2%;">
              <Pagination
                  :data="paginationProduct"
                  v-on:changePage="handleClickInBranchOffice"
              />
            </div>

          </div>
          <div class="page__buttons" style="padding-top: 2%;">
            <button style="background: #ff3128; width: 250px;padding: 15px 20px;border-radius: 15px;font-size: 17px;color: #fff;border: none;display: flex;align-items: center;justify-content: space-between;" @click="this.showModal = false">
              <span>Cerrar</span>
                <i class="fa fa-times-circle"></i>
            </button>
          </div>
        </vue-final-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar'
  import ButtonExport from '@/components/ButtonExport.vue'
  import Pagination from '@/components/Pagination.vue'
  import {
    codeFormat,
    dateFormat,
    conditionalFormatValue
  } from '@/utils/formats'
  import Dropdown from '@/components/Dropdown.vue'
  import OpenArrow from '@/components/OpenArrow.vue'
  import { VueFinalModal } from 'vue-final-modal'
  import CommercialSidebar from '@/components/CommercialSidebar.vue'
  import $ from 'jquery'

  export default {
    name: 'Home',
    components: {
      Navbar,
      ButtonExport,
      Pagination,
      Dropdown,
      OpenArrow,
      CommercialSidebar,
      VueFinalModal
    },
    data() {
      return {
        role: localStorage.getItem('role'),
        type: 'product',
        product_brand: 0,
        product_image: 3,
        nombre_producto: '',
        product_code: '',
        showDropdwon: true,
        dataModal: null,
        showModal: false,
        paginationProduct: [],
        modal: [],
        empty: false,
        brand: '',
        timeout: null,
        products: [],
        products_export: [],
        pagination: [],
        url_importar: '',
        mensaje: '',
        search_branch_office: '',
        columns: [
          {
            label: 'Código de productos',
            field: 'product_code',
            dataFormat: this.codeFormat
          },
          { label: 'Nombre de producto', field: 'product_name' },
          { label: 'Descripción', field: 'product_descripcion' },
          { label: 'Tipo de Producto', field: 'type' },
          { label: 'Marca', field: 'brand' },
          {
            label: 'Fecha de Registro',
            field: 'created_at',
            dataFormat: this.dateFormat
          },
          {
            label: 'Fecha de Actualización',
            field: 'updated_at',
            dataFormat: this.dateFormat
          },
          {
            label: 'Imagen Cargada',
            field: 'product_path',
            dataFormat: this.conditionalFormatValue
          }
        ],
        columnsModal: [
          {
            label: 'Código de Sucursal',
            field: 'branch_code',
          },
          { label: 'Nombre de Sucursal', field: 'branch_name' },
          { label: 'Alias', field: 'branch_nickname' },
          { label: 'Dirección', field: 'branch_direction' },
          { label: 'Referencia', field: 'branch_reference' },
        ]
      }
    },
    // computed:{
    //   search: function () {
    //     let nombre = this.products.filter((item) => item.product_name.toLowerCase().includes(this.nombre_producto.toLowerCase()));
    //     let marca = nombre.filter((item) => item.product_brand_id.toString().includes(this.product_brand.toString()));
    //     let imagen = marca.filter((item) => item.imagen.toString().includes(this.product_image.toString()));
    //     return imagen.filter((item) => item.product_code.toString().toLowerCase().includes(this.product_code.toLowerCase()));
    //   }
    // },
    methods: {
      deleteProduct(id){

        this.$swal({
          title: '¿Deseas eliminar el producto?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            axios.delete("general/product/"+id).then(res => {
              if (res.status === 200){
                this.search()
                this.$swal({
                  position: 'center',
                  icon: 'success',
                  title: 'Eliminado correctamente',
                  showConfirmButton: false,
                  timer: 2000
                })
              }
            })
          }
        })
      },
      onlynumber(evt){
        evt = (evt) ? evt : window.event
        const charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      searchBranchOffice: function() {
        var self = this;
        this.timeout = setTimeout(function () {
          this.openModal(null, 1, self.search_branch_office)
        }.bind(this), 500);
      },
      activateProduct(e, id){
        let data = {
          product_status: (e.target.checked) ? 1 : 0
        }
        axios.put('general/product/'+id, data)
        this.search()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: (e.target.checked) ? 'Activado correctamente': 'Desactivado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      },
      openModal(divID, page = 1, search = ''){
        if(divID){
          this.show('id-dropdown-content'+divID)
          if (this.sucu !== divID){
            this.search_branch_office = ''
          }
            this.sucu = divID
        }
        this.showModal = true
        axios.get("general/product/"+this.sucu, {
          params: { page: page, data: search }
        }).then(res => {
          this.dataModal = res.data.data
          if (res.data.data.branchoffice.total > 0){
            this.productEmpty = false
            this.paginationProduct = res.data.data.branchoffice
          }else{
            this.productEmpty = true
            this.paginationProduct = {}
          }
        })
      },
      show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
      handleClickInParent: function(page) {
        this.getall(page)
      },
      handleClickInBranchOffice: function(page) {
        this.openModal(null, page, this.search_branch_office)
      },
      search: function() {
        clearTimeout(this.timeout);
        var self = this;
        this.timeout = setTimeout(function () {
          let paramSearch = {
            product_code: self.product_code,
            nombre_producto: self.nombre_producto,
            marca: self.product_brand,
            imagen: self.product_image,
          }
          this.getall(1, paramSearch)
        }.bind(this), 500);
      },
      codeFormat,
      dateFormat,
      conditionalFormatValue,
      createProduct() {
        this.$router.push('/client/addproduct')
      },
      clean_filter(){
        this.product_code = '';
        this.nombre_producto = '';
        this.product_brand = 0;
        this.product_image = 3;
        
        this.getall()
      },
      async getBrand(){
        await axios.get('general/elements/brand', { params: {
            product_company_id: localStorage.getItem('company_id')
          }
        }).then(res => {
          this.brand = res.data.data
        })
      },
      handleClick() {
        localStorage.removeItem('token')
        this.$router.push('/login')
      },
      async getall(page = 1, paramSearch = {}) {
        await axios.get('general/product', {params: {
            page: page,
            product_company_id:localStorage.getItem('company_id'),
            product_code: ( typeof paramSearch.product_code === 'undefined' || paramSearch.product_code === '' ) ? null : parseInt(paramSearch.product_code),
            product_name: (paramSearch.nombre_producto !== '') ? paramSearch.nombre_producto : null,
            product_brand_id: (paramSearch.marca === 0) ? null : paramSearch.marca,
            imagen: (paramSearch.imagen === 3) ? null : paramSearch.imagen,
        }}).then( res => {
            this.url_importar = res.data.url  
          if (res.data.data.total > 0){
            this.products = res.data.data.data
            this.products_export = res.data.export
            this.pagination = res.data.data
            this.empty = false
          }else{
            this.products = {}
            this.pagination = {}
            this.empty = true
          }
        })
      },
      showProduct(id) {
        this.$router.push({ path: '/Client/ShowProduct', query: { id: id } })
      },
      async importProduct() {
        let self =  this
        const { value: file } = await this.$swal({
          title: 'IMPORTAR PRODUCTOS',
          html: 'descarga el formato <a href="'+this.url_importar+'">aquí</a><br><br><p>Nota:<br> El archivo debe subirse comprimido en zip y con el nombre fm_import_product.xlsx</p>',
          input: 'file',
          inputAttributes: {
            accept: '.zip',
            'aria-label': ''
          },
          showCancelButton: true,
          confirmButtonText: 'Importar',
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#ff3128',
          confirmButtonColor: '#32ba7c',
          showLoaderOnConfirm: true
        })

        if (file) {
          const reader = new FileReader()
          const formData = new FormData();
          formData.append('file', file);
          formData.append('company_id', localStorage.getItem('company_id'));
          reader.onload = async e => {
            const response = await axios.post('general/product/import', formData).then(
                res => {
                  this.mensaje = ''
                  if (res.data.success){
                    let fl = 0
                    Object.entries(res.data.data).forEach(item=>{
                      let color = ''
                      if (!item[1].status){
                        color = 'red'
                        fl++
                      }
                      this.mensaje += '<p style="color:'+color+'">'+item[1].mensaje + '</p>'
                    })

                    let sms = ''
                    let icon = ''
                    if (Object.entries(res.data.data).length === fl){
                      sms = 'No se importó porque el archivo tiene errores'
                      icon = 'error'
                    }else if (fl===0){
                      sms = 'Se importó correctamente'
                      icon = 'success'
                    }else{
                      sms = 'Se importó pero algunas filas tienen errores, por favor revisar los registros de resultado'
                      icon = 'warning'
                    }

                    this.getall()
                    this.$swal({
                      position: 'center',
                      icon: icon,
                      title: sms,
                      html: '<div style="max-height: 200px; min-height: 30px">'+this.mensaje+'</div>',
                      showConfirmButton: true,
                      confirmButtonColor: '#32ba7c',
                      confirmButtonText: 'Aceptar'
                    })
                  }else {
                    this.$swal({
                      position: 'center',
                      icon: 'error',
                      title: 'Ocurrio un error',
                      showConfirmButton: false,
                      timer: 2000
                    })
                  }
                }
            ).catch(
                function (error) {
                  self.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Formato Invalido',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
            )
          }
          reader.readAsDataURL(file)
        }else{
          this.$swal({
            position: 'center',
            icon: 'error',
            title: 'Adjuntar archivo',
            showConfirmButton: false,
            timer: 2000
          })
        }
      }
    },
    created() {
      this.getall()
      this.getBrand()
      this.company_name = localStorage.getItem('company_name');
    }
  }
</script>

<style scoped>

  /*------NAVBAR------*/
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }

  .home .navbar {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
  }

  .home .navbar__left {
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home .navbar__left img {
    width: 130px;
  }

  .home .navbar__center {
    width: 70%;
    height: 100%;
  }

  .home .navbar__center ul {
    width: 100%;
    height: 100%;
    display: flex;
    list-style: none;
    display: flex;
    justify-content: flex-start;
  }
  .home .navbar__center ul li {
    text-decoration: none;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
  }

  .home .navbar__center ul li::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 0;
    height: 4px;
    background-color: #ff3128;
    transition: 0.3s ease;
  }
  .home .navbar__center ul li:hover {
    color: #ff3128;
  }
  .home .navbar__center ul li:hover::before {
    width: 100%;
  }

  .home .navbar__right {
    display: flex;
  }
  .home .navbar__right .profile {
    display: flex;
    width: 300px;
    height: 100%;
  }

  .home .navbar__right .profile__detail {
    width: 220px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 5px;
  }
  .home .navbar__right .profile__detail p {
    margin: 0;
  }
  .home .navbar__right .profile__detail span {
    color: #938f8f;
    font-weight: 300;
  }

  .home .navbar__right .profile__icon,
  .home .navbar__right .profile__logout {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    color: #ff3128;
    cursor: pointer;
  }
  /*------NAVBAR------*/

  /*-------------------------*/
  a:hover {
    text-decoration: none;
  }
  /*-------------------------*/

  /*------BODY------*/

  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }

  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__sidebar .floating-icon {
    position: absolute;
    right: -15px;
    top: 30px;
    color: #ff3128;
    font-size: 30px;
  }

  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }

  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }
  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }

  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
  }

  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3 ease;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }

  .body__containt {
    height: fit-content;
    min-height: 87vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }

  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }

  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 40px;
  }
  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }
  .body__containt .page__filters .input {
    width: 300px;
    border-radius: 10px;
    border: 1px solid #938f8f;
    display: flex;
    flex-direction: column;
    padding: 7px 15px;
    transition: 0.4s ease;
  }

  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #32ba7c;
  }
  .body__containt .page__buttons .button:nth-child(2) {
    background: #ff3128;
  }
  .body__containt .page__buttons .button:nth-child(3) {
    background: #262626;
  }

  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }

  .body__containt .page__table .table-headers {
    width: 135%;
    height: 50px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 5);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }

  .body__containt .page__table .table-body {
    width: 130%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-body .data {
    width: 104%;
    height: 60px;
    border-radius: 15px;
    display: flex;
    transition: 0.3s ease;
  }

  .body__containt .page__table .table-body .data p {
    width: calc(100% / 9);
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    padding: 0 1rem;
  }
  .body__containt .page__table .table-body .data p:nth-child(1) {
    color: #ff3128;
  }
  .body__containt .page__table .table-body .data p:nth-last-child(1) {
    cursor: pointer;
  }
    .body__sidebar.open{
    display: none;
  }
  /* .body__containt .page__filters input:nth-child(1) {
  width: 300px;
  margin: 0;
  margin-right: 10px;
} */

  
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 7rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  height: 100%;
  overflow-y: auto;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
#columnas{
  column-count:3;
  column-gap:40px;
  column-rule:4px dotted gray;
}
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}
.dropdown {
    display: flex;
    margin: 10px 0;
    font-weight: 300;
    position: relative;
    align-items: center;
    width: calc(100% / 9) !important;
    justify-content: center;
}

  /* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
  }
  .page__filters select{
    padding: 10px 19px;
    width: 54% !important;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;
  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{
    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 20px;
    margin-top: -18px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }
  }
</style>
